var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicOff = function SvgMicOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.377,16.697l1.08-1.08c0.49,0.167,1.012,0.257,1.543,0.257c2.366,0,4.543-1.769,4.543-4.295H18 c0,2.872-2.331,5.246-5.143,5.659V20h-1.714v-2.762C10.53,17.148,9.935,16.965,9.377,16.697z M7.098,14.827 C6.391,13.892,6.006,12.753,6,11.58h1.457c0,0.842,0.242,1.6,0.653,2.237l-1.012,1.012V14.827z M11.969,14.105l2.594-2.594v0.068 c0,1.398-1.14,2.526-2.563,2.526H11.969z M9.556,12.37c-0.085-0.255-0.128-0.522-0.127-0.791V6.526C9.429,5.128,10.577,4,12,4 s2.571,1.128,2.571,2.526l-0.001,0.83L9.556,12.37z M19.111,4L20,4.889L4.889,20L4,19.111L19.111,4z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic-off.b77454c3.svg";
export { ForwardRef as ReactComponent };